import { useTranslation } from 'react-i18next';

import type { Task, TaskSize } from '../../../api/types';
import { TaskCard } from './TaskCard';
import styles from './TaskGroupSection.module.css';

interface TaskGroupSectionProps {
  size: TaskSize;
  tasks: Task[];
  onOpenTask: (taskId: number) => void;
  // PARA-135 — проброс жестов карточки от экрана; onOpenTask сохранён (AC-1a).
  onTakeIntoWork: (task: Task) => void;
  onEditTask: (taskId: number) => void;
}

// PARA-105, AC-9: три явные секции по размеру (SMALL/MEDIUM/BIG).
export function TaskGroupSection({
  size,
  tasks,
  onOpenTask,
  onTakeIntoWork,
  onEditTask,
}: TaskGroupSectionProps): JSX.Element {
  const { t } = useTranslation('tasks');

  return (
    <section className={styles.section} aria-label={size}>
      <h2 className={styles.heading}>{t(`sections.${size}`)}</h2>
      {tasks.map((task) => (
        <TaskCard
          key={task.id}
          task={task}
          onOpen={onOpenTask}
          onTakeIntoWork={onTakeIntoWork}
          onEdit={onEditTask}
        />
      ))}
    </section>
  );
}
